class LinkAccountingEntryCell extends UITableViewCell
{
    
}